import React, {useState, useEffect} from "react";
import {useQuery} from "@apollo/client";
import {MenuItem} from "@mui/material";
import GetAllRegulationTypes from "./gql/GetAllRegulationTypes.graphql";
import {map} from "underscore";
import ControlledSelect from "../components/ControlledSelect";

const RegulationTypeSelect = () => {
  const [regulationTypes, setRegulationTypes] = useState();

  const regulationTypesQuery = useQuery(GetAllRegulationTypes);

  useEffect(() => {
    if (regulationTypesQuery.data) {
      setRegulationTypes(regulationTypesQuery.data.regulationTypes);
    }
  }, [regulationTypesQuery.data]);

  if (!regulationTypes) return null;

  const regulationTypeItems = map(regulationTypes, (regulationType) => {
    return (
      <MenuItem key={regulationType.id} value={regulationType.name}>
        {regulationType.label ?? regulationType.name}
      </MenuItem>
    );
  });

  return (
    <ControlledSelect
      name="regulationType"
      label="Regulation Type"
      options={regulationTypeItems}
      selectProps={{
        required: true,
      }}
    />
  );
};

export default RegulationTypeSelect;
